import { z } from 'zod'
import { oc } from '@orpc/contract'

// The clinic key is write-only at this boundary. It does triple duty — OAuth
// `client_secret`, the token call's `password`, and the SSO hash input — so it is
// accepted on save, stored in dynamic-settings, and never returned by any
// endpoint and never reaches a browser.
export const setOrganizationDoseSpotClinic = oc
  .route({ method: 'POST', path: '/v2/super/organizations/{organizationId}/dosespot-clinic' })
  .input(
    z.object({
      organizationId: z.string().min(1),
      clinicId: z.string().trim().regex(/^\d+$/, 'Expected a numeric DoseSpot clinic id'),
      // DoseSpot documents no shape for the clinic key, so there is nothing to
      // assert beyond non-empty; the live token mint in the handler is the check.
      clinicKey: z.string().trim().min(1),
    }),
  )
  .output(
    z.object({
      configured: z.literal(true),
      clinicId: z.string(),
    }),
  )

export const getOrganizationDoseSpotStatus = oc
  .route({ method: 'GET', path: '/v2/super/organizations/{organizationId}/dosespot-clinic' })
  .input(z.object({ organizationId: z.string().min(1) }))
  .output(
    z.object({
      configured: z.boolean(),
      clinicId: z.string().optional(),
    }),
  )
